module.exports = __webpack_public_path__ + "img/叶坪公略亭.99ecb693.png";